import React, {useEffect, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import {useEventService} from "../../services/event-service";
import InitialLoading from "../../components/initial-loading";
import {useAuth} from "../../context/auth";
import EventSchedule from "../../components/event-schedule";
import {AppEvents, AppRoutes} from "../../utils/constants";
import {Nav} from "react-bootstrap";
import Tab from "react-bootstrap/Tab";
import {useNotifyEventsService} from "../../services/notify-events-service";

export default function Schedule () {
  const [loaded, setLoaded] = useState(false);
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [tab, setTab] = useState('upcoming');
  const [showLoadMore, setShowLoadMore] = useState(false);

  const {addErrorMessage} = useGlobalNotificationMessage();
  const eventsService = useEventService();
  const auth = useAuth();
  const nes = useNotifyEventsService();

  useEffect(() => {
    reloadEvents();
    nes.on(AppEvents.attendanceChanged, reloadEvents);
    // eslint-disable-next-line
  }, []);

  function reloadEvents(key=null){
    if (!key){
      key = tab;
    }
    if (key==='past'){
      if (pastEvents.length===0) {
        setLoaded(false);
      }
      eventsService.getUserPastList(auth.currentUser?.id).then((_events) => {
        setPastEvents(_events.reverse() || []);
        if (_events?.length>=20){
          setShowLoadMore(true);
        } else setShowLoadMore(false);
        setLoaded(true);
      }).catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage);
      });
    }
    else {
      if (upcomingEvents.length===0) {
        setLoaded(false);
      }
      eventsService.getUserList(auth.currentUser?.id).then((_events) => {
        setUpcomingEvents(_events || []);
        if (_events?.length>=20){
          setShowLoadMore(true);
        } else setShowLoadMore(false);
        setLoaded(true);
      }).catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage);
      });
    }
  }

  function loadMoreClasses(key=null){
    if (!key){
      key = tab;
    }
    if (key==='past'){
      eventsService.getUserPastList(auth.currentUser?.id, {from: pastEvents[pastEvents.length-1].datetime})
          .then((_events) => {
            //we make unique check before adding the next set
            let idSet = new Set(pastEvents.map(event => event.id));
            _events = _events.filter(event => !idSet.has(event.id));

            setPastEvents([...pastEvents, ..._events.reverse()]);
            if (_events?.length>=20){
              setShowLoadMore(true);
            } else setShowLoadMore(false);
            setLoaded(true);
          }).catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage);
      });
    }
    else {
      eventsService.getUserList(auth.currentUser?.id, {from: upcomingEvents[upcomingEvents.length-1].datetime})
          .then((_events) => {
            //we make unique check before adding the next set
            let idSet = new Set(upcomingEvents.map(event => event.id));
            _events = _events.filter(event => !idSet.has(event.id));

            setUpcomingEvents([...upcomingEvents, ..._events]);
            if (_events?.length>=20){
              setShowLoadMore(true);
            } else setShowLoadMore(false);
            setLoaded(true);
          }).catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage);
      });
    }
  }

  return (
      <>

        {!loaded && <InitialLoading/>}

        {loaded && <>
          <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
            <div className={"container"}>
              <div className={"row"}>
                <div className={"col-sm-12 col-md-7 col-lg-6"}>
                  <h1 className="header-stripe-blue">Schedule</h1>
                  <p>Your scheduled events</p>
                </div>
              </div>
            </div>
          </Section>

          <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
            <div className={"container"}>
              <div className={"row"}>
                <div className={"col-sm-12"}>

                  <Tab.Container
                      activeKey={tab}
                      onSelect={(k)=>{
                        setTab(k);
                        reloadEvents(k);
                      }}
                  >
                    <Nav variant="pills" className="">
                      <Nav.Item>
                        <Nav.Link eventKey="upcoming">Upcoming</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="past">Past/Cancelled</Nav.Link>
                      </Nav.Item>
                    </Nav>

                    <Tab.Content className="mt-3">

                      <Tab.Pane eventKey="upcoming">
                        <div className="card shadow rounded-3">
                          <div className="card-body p-4 py-5">
                            {upcomingEvents?.length === 0 &&
                                <div className="col-sm-12 col-md-6 mb-5">
                                  <h5>Your calendar is empty.</h5>
                                  <p>All your events will appear here in chronological order.</p>
                                </div>
                            }
                            {upcomingEvents?.length > 0 &&
                                <div className="bg-light p-2 rounded-3">
                                  <EventSchedule events={upcomingEvents} link={`${AppRoutes.events.path}/EID`} classes={'cell-hover-effect-subtle'}/>
                                  {showLoadMore && <div className="text-center"><button className="btn btn-outline-primary my-2" onClick={()=>loadMoreClasses()}>Load more events</button></div>}
                                </div>
                            }
                          </div>
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="past">
                        <div className="card shadow rounded-3">
                          <div className="card-body p-4 py-5">
                            {pastEvents?.length === 0 &&
                                <div className="col-sm-12 col-md-6 mb-5">
                                  <h5>Your calendar is empty.</h5>
                                  <p>All your events will appear here in chronological order.</p>
                                </div>
                            }
                            {pastEvents?.length > 0 &&
                                <div className="bg-light p-2 rounded-3">
                                  <EventSchedule events={pastEvents} link={`${AppRoutes.events.path}/EID`} classes={'cell-hover-effect-subtle'}/>
                                  {showLoadMore && <div className="text-center"><button className="btn btn-outline-primary my-2" onClick={()=>loadMoreClasses()}>Load more events</button></div>}
                                </div>
                            }
                          </div>
                        </div>
                      </Tab.Pane>

                    </Tab.Content>
                  </Tab.Container>

                </div>
              </div>
            </div>
          </Section>

        </>}

      </>
  );
}

Schedule.getLayout = function getLayout(page) {
  return (
      <MainLayout>
        {page}
      </MainLayout>
  )
}